import React, { Component } from 'react';
import { LANGUAGES } from '../_i18n/languages';
import translations from '../_i18n/translations.json';
import { FormattedMessage, injectIntl, IntlProvider } from 'react-intl';

const LANG_FLAGS = {
    pt: '🇧🇷',
    es: '🇪🇸',
    fr: '🇫🇷',
    it: '🇮🇹',
    ru: '🇷🇺',
    de: '🇩🇪',
    nl: '🇳🇱',
    en: '🇺🇸'
};

const LANG_NAMES = {
    pt: 'Português',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    ru: 'Русский',
    de: 'Deutsch',
    nl: 'Nederlands',
    en: 'English'
};

class LangCheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLangNotify: false,
            userLanguage: null
        };
        this.timer1 = null;
        this.timer2 = null;
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            try {
                const detectBrowserLanguage = require('detect-browser-language');
                const rawLang = String(detectBrowserLanguage()).split("-")[0].toLowerCase();
                if (LANGUAGES[rawLang]) {
                    this.setState({ userLanguage: rawLang });
                    this.timer1 = setTimeout(() => {
                        this.setState({ showLangNotify: true });
                        this.timer2 = setTimeout(() => {
                            this.setState({ showLangNotify: false });
                        }, 20000);
                    }, 1800);
                }
            } catch (e) {
                // Ignore detection errors in headless / SSR
            }
        }
    }

    componentWillUnmount() {
        if (this.timer1) clearTimeout(this.timer1);
        if (this.timer2) clearTimeout(this.timer2);
    }

    checkLanguage() {
        const usrLang = this.state.userLanguage;
        if (!usrLang || !LANGUAGES[usrLang]) {
            return true;
        }
        const currentLang = LangCheck.getCurrentLang(this.props);
        return usrLang === currentLang;
    }

    render() {
        const { userLanguage, showLangNotify } = this.state;
        if (!showLangNotify || this.checkLanguage() || !userLanguage || !LANGUAGES[userLanguage]) {
            return null;
        }

        const targetUrl = (this.props.location.pathname.split('/')[1].length <= 2 ?
            `/${userLanguage}` :
            `/${this.props.location.pathname.split('/')[1]}/${userLanguage}`)
            + (this.props.paramPath ? `/${this.props.paramPath}` : '');

        const flag = LANG_FLAGS[userLanguage] || '🌐';
        const langName = LANG_NAMES[userLanguage] || userLanguage.toUpperCase();

        return (
            <IntlProvider
                locale={userLanguage}
                defaultLocale="en"
                messages={translations[LANGUAGES[userLanguage]['code']]}
            >
                <aside
                    className="floating-lang-notify"
                    aria-label="Language suggestion"
                >
                    <div className="d-flex align-items-center gap-2">
                        <span className="floating-lang-flag" role="img" aria-label={langName}>
                            {flag}
                        </span>
                        <div className="floating-lang-content">
                            <span className="floating-lang-text">
                                <FormattedMessage id="body.lang.suggest" />
                            </span>
                            <a
                                href={targetUrl}
                                className="floating-lang-btn"
                            >
                                {langName} ({userLanguage.toUpperCase()}) →
                            </a>
                        </div>
                        <button
                            type="button"
                            className="floating-lang-close"
                            onClick={() => this.setState({ showLangNotify: false })}
                            aria-label="Dismiss"
                            title="Dismiss"
                        >
                            ✕
                        </button>
                    </div>
                </aside>
            </IntlProvider>
        );
    }

    static getCurrentLang(props) {
        if (!props || !props.location || !props.location.pathname) {
            return 'en';
        }
        const aPath = props.location.pathname.split('/');
        if (aPath[2] && LANGUAGES[aPath[2]]) {
            return aPath[2];
        }
        if (aPath[1] && LANGUAGES[aPath[1]]) {
            return aPath[1];
        }
        return 'en';
    }

    static getOgLocale(lang) {
        const langMap = {
            pt: 'pt_BR',
            es: 'es_ES',
            fr: 'fr_FR',
            it: 'it_IT',
            ru: 'ru_RU',
            de: 'de_DE',
            nl: 'nl_NL',
            en: 'en_US'
        };
        return langMap[lang] || 'en_US';
    }

    static pathLocation(props, country) {
        let aPath = props.location.pathname.split('/');
        if (aPath[1] && aPath[1].length !== 2) {
            return `/${aPath[1]}${country ? '/' : ''}${country}`;
        }
        return country ? `/${country}` : '';
    }
}

export default injectIntl(LangCheck);